import React, { useMemo } from 'react';
import { Spinner } from 'reactstrap';
import { placeholder } from '@codemirror/view';
import styled from '@emotion/styled';
import classnames from '../../util/classnames';
import { Logo } from '../_general/Logo';
import CentralizedFullScreenContainer from '../CentralizedFullScreenContainer';


type LoaderProps = {
  children?: React.ReactNode,
  sm?: boolean,
  text?: string | React.ReactNode,
  color?: string,
  size?: number | null,
  padding?: number,
  fullscreen?: boolean,
  dots?: boolean,
  spinner?: boolean,
  inline?: boolean
};

function Loader({
  children, sm, text, color = 'secondary', size = null, padding = 4, fullscreen, dots = false, spinner = false, inline = false
}: LoaderProps) {
  const loaderSize = useMemo(() => size ?? 80, [size]);

  const logoStyle = useMemo(
    () => ({
      width: fullscreen ? 80 : 40,
      height: fullscreen ? 80 : 40,
      objectFit: 'contain',
    }),
    [fullscreen]
  );

  const loaderImage = useMemo(() => {
    if (spinner) {
      return <Spinner color="primary" size={sm ? 'sm' : ''} />;
    }

    if (dots) {
      return <div className="dots-loader" />;
    }

    const AnyLogo = Logo as any;
    return (
      <div className="logo-loader">
        <AnyLogo className="logo-loader" style={logoStyle} />
      </div>
    );
  }, [dots, spinner, placeholder]);

  const loader = useMemo(
    () => (
      <div className={classnames(`modern-loader`, { sm, 'd-flex align-items-center flex-row': inline })}>
        <LogoWrapperDiv fullscreen={fullscreen} loaderSize={loaderSize}>{loaderImage}</LogoWrapperDiv>
        {children && <div className="loader-text">{children}</div>}
      </div>
    ),
    [sm, children, loaderImage, inline]
  );

  return fullscreen ? (
    <CentralizedFullScreenContainer>
      {loader}
      {text && <p className={`text-${color} mt-3`}>{text}</p>}
    </CentralizedFullScreenContainer>
  ) : (
    <div className="loader-center">{loader}</div>
  );
}

const LogoWrapperDiv = styled("div")<{
  fullscreen?: boolean,
  loaderSize: number,
}>(({
  fullscreen,
  loaderSize,
}) => ({
  position: 'relative',
  width: fullscreen ? loaderSize : 40,
  height: fullscreen ? loaderSize : 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))


export default Loader;
